import { useAppSelector } from '../../../store';
import { useEffect, useMemo, useState } from 'react';
import { getTabsOfGrouper } from 'entities/task/lib/getTabsOfGrouper';

export const useTaskList = () => {
    const { tabs, filteredTabs, isShowCompleted, isFiltered } = useAppSelector(
        (state) => state.tasksInformationReducer
    );
    const { isLoading: isLoadingFromStore } = useAppSelector((state) => state.tasksReducer);

    const [isLoading, setIsLoading] = useState(isLoadingFromStore);

    useEffect(() => {
        let timeout: NodeJS.Timeout;
        if (isLoadingFromStore) {
            setIsLoading(isLoadingFromStore);
        } else {
            timeout = setTimeout(() => {
                setIsLoading(false);
            }, 0);
        }
        return () => clearTimeout(timeout);
    }, [isLoadingFromStore]);

    const tabsOfGrouper = useMemo(() => {
        if (filteredTabs) return getTabsOfGrouper(filteredTabs?.list);
        return getTabsOfGrouper(tabs?.list);
    }, [tabs?.list, filteredTabs]);

    const isEmptyTasksList = useMemo(() => {
        return tabsOfGrouper.every((tab) => tabs?.list[tab]?.length === 0);
    }, [tabs?.list, tabsOfGrouper]);

    const noTaskFound = useMemo(() => {
        if (filteredTabs === null) return false;
        const keys = Object.keys(filteredTabs.list || {});
        return keys.every((key) => filteredTabs.list[key].length === 0);
    }, [filteredTabs]);

    return {
        tabsOfGrouper,
        isLoading,
        isEmptyTasksList,
        isShowCompleted,
        isFiltered,
        filteredTabs,
        tabs,
        noTaskFound,
    };
};
